import { FormikValues } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";

import { Grid, MenuItem, Select } from "@material-ui/core";

import FormCard from "../FormCard";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import { makeStyles } from "@material-ui/styles";
import Label from "../../Label";
import { PhotovoltaicsCostDistributionType } from "../../../api/types";

export enum PhotovoltaicsConfigFormFields {
  CostDistributionType = "costDistributionType",
}

export interface PropertyEvFormValues extends FormikValues {
  costDistributionType: PhotovoltaicsCostDistributionType | undefined;
}

interface Props {
  values: PropertyEvFormValues;
  onFieldChange: (fieldName: string, value: string) => void;
  isEditable?: boolean;
}

const useStyles = makeStyles(() => ({
  grid: {
    maxWidth: 368,
  },
  select: {
    width: "100%",
  },
}));

function PhotovoltaicsConfigForm({
  values,
  onFieldChange,
  isEditable = true,
}: Props) {
  const classes = useStyles();
  const { t } = useTranslation();

  const { costDistributionType } = values;

  const costDistributionTypesMenuItems = Object.values(
    PhotovoltaicsCostDistributionType
  ).map((type) => (
    <MenuItem value={type} key={type}>
      {t(type)}
    </MenuItem>
  ));

  const onChange = (
    event: React.ChangeEvent<{ name?: string | undefined; value: unknown }>,
    field: PhotovoltaicsConfigFormFields
  ) => {
    const eventValue = event.target.value;
    if (typeof eventValue === "string") {
      onFieldChange(field, eventValue);
    }
  };

  return (
    <FormCard
      header={t("photovoltaicsLabel")}
      headerIcon={<WbSunnyIcon fontSize="default" />}
    >
      <Grid container spacing={3} className={classes.grid}>
        <Grid item xs={12}>
          <Label value={t("costDistributionType")} />
          <Select
            labelId="costDistributionType-label"
            id="costDistributionType-select"
            value={costDistributionType}
            className={classes.select}
            disabled={!isEditable}
            onChange={(event) => {
              onChange(
                event,
                PhotovoltaicsConfigFormFields.CostDistributionType
              );
            }}
            color="secondary"
            disableUnderline
          >
            {costDistributionTypesMenuItems}
          </Select>
        </Grid>
      </Grid>
    </FormCard>
  );
}

export default PhotovoltaicsConfigForm;
